import debounce from 'lodash/debounce';
import { startTransition, useState, useMemo, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { API, ShareAPI } from '../../../API';
import Async from 'react-select/async';
import { components } from 'react-select';
import { platformIconsMapping } from '../../../utils/platforms';
import { showRequestError } from '../../../utils/requestError';
import * as d3 from 'd3';
import { ALL_STATUSES_QUERY } from '../../../utils/actors';


const formatNumberSignificant = d3.format('.3~s',);

export const SourceChooser = ({onChange, narrativeId, selected = [], onClose, isShare}) => {
  const { t } = useTranslation();
  const [searchKey, setSearchKey] = useState("");
  const [defaultOptions, setDefaultOptions] = useState([]);

  let api = isShare ? ShareAPI : API;

  const handleInputChanged = (input, { action }) => {
    if (action === "set-value") {
      return;
    }

    setDefaultOptions([]);
    setSearchKey(input);
  };

  const getSources = useMemo(() => {
    let abortController = null;

    return debounce((inputValue, callback) => {
      // Cancel previous request
      if (abortController) {
        abortController.abort();
      }

      // Create new AbortController for this request
      abortController = new AbortController();

      api.fetch(
        'GET',
        `/API/v2/actors?narrative_id=${narrativeId}&q=${inputValue}&sorting=-relevance&${ALL_STATUSES_QUERY}`,
        null,
        null,
        abortController.signal
      ).then((data) => {
        let optionsList = data.objects.map((source) => {
          let followers_cnt = source?.audience;

          return {
            value: source.id,
            label: source.name,
            icon: platformIconsMapping[source.source_type] || platformIconsMapping['WEB'],
            followers_count: followers_cnt || 0,
          };
        });
        setDefaultOptions(optionsList);
        callback(optionsList);
      }).catch((error) => {
        showRequestError(error, t('Source filter'));
        callback([]);
      });
    }, 500);
  }, [narrativeId]);

  useEffect(() => {
    return () => {
      getSources.cancel();
    };
  }, [getSources]);

  const sourcesPromiseOptions = (inputValue) => {
    if (!inputValue) {
      return [];
    }

    return new Promise((resolve) => {
      getSources(inputValue, resolve);
    });
  };

  const { Option } = components;
  const IconOption = props => {
    return <Option {...props}>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <span style={{display: 'inline-flex', alignItems: 'center', width: '14px', height: '14px', position: "relative", marginRight: '10px'}}>
          {props.data.icon}
        </span> {props.data.label} <b>({formatNumberSignificant(props.data.followers_count)})</b>
      </div>
    </Option>
  };

  return(
    <div className='chooser source-search-filter'>
      <Async
        className="select-filter"
        classNamePrefix="select-filter"
        cacheOptions
        defaultOptions={defaultOptions}
        isMulti={true}
        components={{ Option: IconOption }}
        loadOptions={sourcesPromiseOptions}
        placeholder={t('Please enter at least 1 symbol')}
        noOptionsMessage={()=> t('Please enter at least 1 symbol')}
        loadingMessage={() => t('Loading...')}
        name="sources"
        value={selected}
        onChange={(values) => startTransition(() => onChange(values))}
        onMenuClose={() => onClose()}
        closeMenuOnSelect={false}
        blurInputOnSelect={false}
        inputValue={searchKey}
        onInputChange={handleInputChanged}
      />
    </div>
  )
}